module.exports = __webpack_public_path__ + "sovdapp/img/footer-logo2-gray.dd5aebd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-logo2-gray.svg
// module id = YDW9
// module chunks = 1 2 3